import React, { useState, useEffect } from 'react';
import { db } from '../../config/firebase';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import PageLayout from '../Shared/PageLayout';

export default function MaintenanceSettings() {
  const [enabled, setEnabled] = useState(false);
  const [allowChess, setAllowChess] = useState(true);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState('');

  useEffect(() => { load(); }, []);

  async function load() {
    try {
      const snap = await getDoc(doc(db, 'settings', 'maintenance'));
      if (snap.exists()) {
        const d = snap.data();
        setEnabled(!!d.enabled);
        setAllowChess(d.allowChess !== false);
        setMessage(d.message || '');
      }
    } catch (e) { console.error(e); }
    setLoading(false);
  }

  async function handleSave() {
    setSaving(true);
    setSuccess('');
    try {
      await setDoc(doc(db, 'settings', 'maintenance'), {
        enabled,
        allowChess,
        message,
        updatedAt: serverTimestamp(),
      }, { merge: true });
      setSuccess('Imehifadhiwa!');
      setTimeout(() => setSuccess(''), 3000);
    } catch (e) {
      console.error(e);
    }
    setSaving(false);
  }

  if (loading) {
    return <PageLayout><div style={styles.loading}>Inapakia...</div></PageLayout>;
  }

  return (
    <PageLayout>
      <div style={styles.pageHeader}>
        <div style={styles.pageTitle}>Maintenance Mode</div>
        <div style={styles.pageSub}>
          Funga tovuti kwa umma (Donor, Staff forms, taarifa za watu) huku Admin/Staff wakiendelea kufanya kazi.
        </div>
      </div>

      {enabled && (
        <div style={styles.warningBanner}>
          Maintenance mode iko <strong>ON</strong> sasa hivi — umma hauwezi kuona tovuti (isipokuwa Chess kama umeruhusu hapo chini).
        </div>
      )}

      <div style={styles.panel}>
        <div style={styles.toggleRow}>
          <div>
            <div style={styles.toggleLabel}>Funga tovuti kwa umma</div>
            <div style={styles.toggleHint}>
              Donor page, Login ya Donor, na taarifa nyingine za umma hazitaonekana. Admin/Staff bado wataweza kuingia.
            </div>
          </div>
          <label style={styles.switch}>
            <input
              type="checkbox"
              checked={enabled}
              onChange={e => setEnabled(e.target.checked)}
              style={{ display: 'none' }}
            />
            <div style={{ ...styles.switchTrack, background: enabled ? '#14452F' : '#D1D5DB' }}>
              <div style={{ ...styles.switchThumb, transform: enabled ? 'translateX(20px)' : 'translateX(0)' }} />
            </div>
          </label>
        </div>

        <div style={styles.divider} />

        <div style={styles.toggleRow}>
          <div>
            <div style={styles.toggleLabel}>Chess ibaki wazi</div>
            <div style={styles.toggleHint}>
              Chess Lobby, Bot, Puzzle, Learn na Tournaments zitaendelea kufanya kazi kwa umma hata wakati maintenance ipo ON.
            </div>
          </div>
          <label style={styles.switch}>
            <input
              type="checkbox"
              checked={allowChess}
              onChange={e => setAllowChess(e.target.checked)}
              style={{ display: 'none' }}
            />
            <div style={{ ...styles.switchTrack, background: allowChess ? '#14452F' : '#D1D5DB' }}>
              <div style={{ ...styles.switchThumb, transform: allowChess ? 'translateX(20px)' : 'translateX(0)' }} />
            </div>
          </label>
        </div>

        <div style={styles.divider} />

        <div style={styles.formGroup}>
          <label style={styles.formLabel}>Ujumbe wa Coming Soon (Kiswahili)</label>
          <textarea
            style={styles.textarea}
            value={message}
            onChange={e => setMessage(e.target.value)}
            placeholder="Tunafanya maboresho kwenye mfumo wetu ili kuhakikisha taarifa za jamii yetu zinalindwa vizuri zaidi. Tutarudi hivi karibuni."
            rows={4}
          />
        </div>

        {success && <div style={styles.successMsg}>{success}</div>}

        <button style={styles.saveBtn} onClick={handleSave} disabled={saving}>
          {saving ? 'Inahifadhi...' : 'Hifadhi Mabadiliko'}
        </button>
      </div>

      <div style={styles.noteBox}>
        <strong>Kumbuka:</strong> Hata maintenance ikiwa ON, wewe (Admin) na Staff wanaweza kuingia kupitia <code>/login</code> kama kawaida na kuendelea kufanya kazi nyuma ya pazia — mfumo huu unaathiri wageni wa umma pekee.
      </div>
    </PageLayout>
  );
}

const styles = {
  loading: { textAlign: 'center', padding: '60px 0', color: '#6B7280' },
  pageHeader: { marginBottom: '20px' },
  pageTitle: { fontFamily: "'Fraunces', Georgia, serif", fontSize: '24px', color: '#1C1C1E' },
  pageSub: { fontSize: '12.5px', color: '#6B7280', marginTop: '4px' },
  warningBanner: { background: '#FFF3E0', border: '1px solid #FFE0B2', color: '#E65100', padding: '14px 18px', borderRadius: '12px', fontSize: '13.5px', marginBottom: '18px' },
  panel: { background: '#fff', borderRadius: '16px', padding: '22px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)', border: '1px solid rgba(0,0,0,0.04)', marginBottom: '18px' },
  toggleRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '20px' },
  toggleLabel: { fontSize: '14px', fontWeight: '600', color: '#1C1C1E' },
  toggleHint: { fontSize: '12px', color: '#6B7280', marginTop: '3px', maxWidth: '440px' },
  switch: { cursor: 'pointer', flexShrink: 0 },
  switchTrack: { width: '44px', height: '24px', borderRadius: '99px', position: 'relative', transition: 'background 0.2s' },
  switchThumb: { width: '18px', height: '18px', borderRadius: '50%', background: '#fff', position: 'absolute', top: '3px', left: '3px', transition: 'transform 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.3)' },
  divider: { height: '1px', background: '#F3F4F6', margin: '20px 0' },
  formGroup: { display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '4px' },
  formLabel: { fontSize: '12.5px', color: '#6B7280', fontWeight: '500' },
  textarea: { padding: '12px 14px', borderRadius: '10px', border: '1.5px solid #E5E7EB', background: '#FAF9F5', fontFamily: 'inherit', fontSize: '13.5px', color: '#1C1C1E', outline: 'none', resize: 'vertical' },
  successMsg: { background: '#EAF3EC', border: '1px solid #BBD8C4', color: '#14452F', padding: '10px 14px', borderRadius: '10px', fontSize: '12.5px', marginTop: '14px' },
  saveBtn: { marginTop: '16px', padding: '13px', width: '100%', background: 'linear-gradient(135deg, #14452F, #1F6B45)', color: '#fff', border: 'none', borderRadius: '10px', fontFamily: 'inherit', fontSize: '14px', fontWeight: '600', cursor: 'pointer' },
  noteBox: { background: '#E3F2FD', border: '1px solid #BBDEFB', color: '#1565C0', padding: '14px 18px', borderRadius: '12px', fontSize: '12.5px', lineHeight: 1.6 },
};
